import React from "react";
import { FaTimes } from "react-icons/fa";
import MaxMinutesSlider from "./MaxMinutesSlider.tsx";

// Small popover the legend expands into on desktop; holds the knobs that
// don't need to clutter the main panel.
const SettingsPanel = ({
  maxMinutes,
  setMaxMinutes,
  onClose,
}: {
  maxMinutes: number;
  setMaxMinutes: (mins: number) => void;
  onClose: () => void;
}) => (
  <div className="w-72 rounded-xl border border-gray-200 bg-white/95 p-4 shadow-lg backdrop-blur">
    <div className="flex items-center justify-between pb-1">
      <h1 className="text-sm font-semibold text-gray-700">Settings</h1>
      <button className="text-gray-400 hover:text-gray-600" onClick={onClose}>
        <FaTimes />
      </button>
    </div>
    <MaxMinutesSlider maxMinutes={maxMinutes} setMaxMinutes={setMaxMinutes} />
  </div>
);

export default SettingsPanel;
